import { MouseEventHandler } from "react"
import { Box, Tooltip } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFileArrowDown as faFileArrowDownLight } from "@fortawesome/pro-light-svg-icons"
import { faFileArrowDown as faFileArrowDownRegular } from "@fortawesome/pro-regular-svg-icons"

import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"
import { LoadingIconButton } from "../buttons/LoadingButton"

type StyleProps = Readonly<{ bordered: boolean }>

const useStyles = makeStyles<StyleProps>()((theme, { bordered }) => ({
    button: {
        padding: ".75rem",
        borderRadius: ".75rem",
        color: theme.palette.action.active,
        minWidth: "2.5rem",
        height: "2.5rem",
        ...(bordered && {
            border: `1px solid ${theme.palette.divider}`,
            backgroundColor: theme.palette.common.white,
            color: theme.palette.common.black,
        }),
    },
}))

type StandardExportButtonProps = Readonly<{
    loading?: boolean
    onClick?: MouseEventHandler<HTMLButtonElement>
    disabled?: boolean
    className?: string
    bordered?: boolean
}>

export function StandardExportButton({
    loading = false,
    onClick,
    disabled = false,
    className,
    bordered = false,
}: StandardExportButtonProps) {
    const { classes, cx } = useStyles({ bordered })

    return (
        <LocalizedStrict id="export-button-export-text" attrs={{ title: true }}>
            <Tooltip title="Export">
                <Box component="span">
                    <LocalizedStrict id="export-button-export-text" attrs={{ "aria-label": true }}>
                        <LoadingIconButton
                            loading={loading}
                            onClick={onClick}
                            disabled={disabled}
                            className={cx(classes.button, className)}
                            aria-label="Export"
                        >
                            <FontAwesomeIcon icon={bordered ? faFileArrowDownLight : faFileArrowDownRegular} size="xs" />
                        </LoadingIconButton>
                    </LocalizedStrict>
                </Box>
            </Tooltip>
        </LocalizedStrict>
    )
}
